import { Dispatch, SetStateAction, useCallback } from "react"
import { Grid } from "@mui/material"

import { ResourceFiltersTypes } from "../../../createOrderTypes"
import { FilterSearch } from "../../FilterSearch"
import { ViewType } from "../resourceBookingCalendars/BookingViewMenu"

import { BookPeriodFilter } from "./BookPeriodFilter"
import { MeetingAvailabilityFilter } from "./MeetingAvailabilityFilter"
import { ResourceFilterMenu } from "./ResourceFilterMenu"

type ResourceFiltersProps = Readonly<{
    filters: ResourceFiltersTypes
    setFilters: Dispatch<SetStateAction<ResourceFiltersTypes>>
    selectedView: ViewType
    isTimeline?: boolean
    userId: number
    isSpecialFlow: boolean
    isRecurringBooking?: boolean
    /** Outlook only: the meeting window the availability chip filters against exists. */
    hasMeetingWindow?: boolean
    /** Remounts the chips, which otherwise seed from `filters` only once — see `ResourceFilterMenu`. */
    chipsSeed?: number
}>

export function ResourceFilters({
    filters,
    userId,
    setFilters,
    selectedView,
    isTimeline,
    isSpecialFlow,
    isRecurringBooking = false,
    hasMeetingWindow,
    chipsSeed,
}: ResourceFiltersProps) {
    const handleSearch = useCallback(
        (searchText: string) => {
            setFilters((prev) => {
                if (prev.search === searchText) return prev
                return { ...prev, search: searchText }
            })
        },
        [setFilters],
    )

    const isTimelineView = selectedView === ViewType.TIMELINE

    return (
        <Grid container gap="1rem" alignItems="center" flexWrap="nowrap">
            <FilterSearch search={filters.search} setSearch={handleSearch} debounceMs={400} />
            {isTimelineView && (
                <BookPeriodFilter
                    isBookedPeriod={!!filters.isBookedPeriod}
                    setFilters={setFilters}
                    isSpecialFlow={isSpecialFlow}
                    isRecurringBooking={isRecurringBooking}
                />
            )}
            {isTimelineView && isSpecialFlow && hasMeetingWindow && (
                <MeetingAvailabilityFilter isActive={!!filters.onlyAvailableForMeeting} setFilters={setFilters} />
            )}
            <ResourceFilterMenu
                key={chipsSeed}
                filters={filters.filters}
                userId={userId}
                setFilters={setFilters}
                isTimeline={isTimeline}
            />
        </Grid>
    )
}
